import { useMutation } from "@apollo/client/react";
import {
  CreateFeedbackResponse,
  CreateFeedbackResponseVariables,
} from "__generated__/types";
import { CancelOrSubmit } from "common/buttons";
import { MarkdownField } from "common/components/forms/MarkdownField";
import { MutationLoadingOrError } from "common/components/forms/MutationLoadingOrError";
import { markdownInput } from "common/input-types";
import gql from "graphql-tag";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";

const MUTATION = gql`
  mutation CreateFeedbackResponse($input: CreateFeedbackResponseInput!) {
    createFeedbackResponse(input: $input) {
      feedback {
        id
      }
    }
  }
`;

interface FormValues {
  answer: string;
}

interface Props {
  id: string;
  cancel(): void;
  complete(): void;
}

export const FeedbackAnswerForm: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  cancel,
  complete,
}) => {
  const methods = useForm<FormValues>();
  const { handleSubmit } = methods;

  const [mutate, { loading, error }] = useMutation<
    CreateFeedbackResponse,
    CreateFeedbackResponseVariables
  >(MUTATION);

  const onSubmit = async (data: FormValues) => {
    const result = await mutate({
      variables: {
        input: {
          id,
          body: markdownInput(data.answer),
        },
      },
    });

    if (result.data) {
      complete();
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <MarkdownField<FormValues>
          name="answer"
          title="Skriv inn svaret ditt her"
          required={true}
        />

        <MutationLoadingOrError loading={loading} error={error} />

        <CancelOrSubmit
          onCancel={cancel}
          submitText="Send svar"
          isLoading={loading}
        />
      </form>
    </FormProvider>
  );
};
